import React from 'react';
import './Stats.css';

interface StatsProps {
  years: string;
  clients: string;
  satisfaction: string;
}

const Stats: React.FC<StatsProps> = ({ years, clients, satisfaction }) => {
  return (
    <section className="stats">
      <div className="stats-container">
        <div className="stats-content">
          <div className="stats-image-wrapper">
            <img 
              src="/assets/stats/cta.jpg" 
              alt="Modern luxury home" 
              className="stats-image"
              onError={(e) => {
                // Fallback to original image if local image not found
                const target = e.target as HTMLImageElement;
                if (!target.src.includes('api.builder.io')) {
                  target.src = 'https://api.builder.io/api/v1/image/assets/TEMP/46b7939e5bebf1b51c9bf6b1599f55e6c8e8dbea?width=2880';
                }
              }}
            />
            <div className="stats-image-fade"></div>
          </div>
          <div className="stats-content-overlay">
            <div className="stats-text-section">
              <h2 className="stats-headline">
                We will find great rate
              </h2>
              <div className="stats-cta-buttons">
                <button className="stats-cta-primary">
                  Get your rate
                </button>
                <button className="stats-cta-secondary">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.28521 6.63989C6.80721 7.72711 7.5188 8.74609 8.41998 9.64727C9.32116 10.5485 10.3401 11.26 11.4274 11.782C11.5209 11.8269 11.5676 11.8494 11.6268 11.8666C11.8371 11.9279 12.0953 11.8839 12.2733 11.7564C12.3234 11.7205 12.3663 11.6777 12.452 11.5919C12.7143 11.3297 12.8454 11.1986 12.9772 11.1129C13.4744 10.7897 14.1153 10.7897 14.6125 11.1129C14.7443 11.1986 14.8754 11.3297 15.1376 11.5919L15.2838 11.7381C15.6823 12.1367 15.8816 12.3359 15.9899 12.55C16.2052 12.9756 16.2052 13.4783 15.9899 13.904C15.8816 14.1181 15.6823 14.3173 15.2838 14.7159L15.1655 14.8342C14.7683 15.2314 14.5697 15.43 14.2997 15.5817C14.0000 15.7500 13.5347 15.8710 13.1910 15.8700C12.8813 15.8691 12.6696 15.8090 12.2463 15.6888C9.97125 15.0431 7.82448 13.8247 6.03350 12.0338C4.24251 10.2428 3.02415 8.09600 2.37843 5.82095C2.25827 5.39762 2.19819 5.18595 2.19727 4.87624C2.19625 4.53258 2.31727 4.06721 2.48559 3.76758C2.63727 3.49755 2.83588 3.29894 3.23310 2.90173L3.35132 2.78350C3.74991 2.38492 3.94920 2.18563 4.16323 2.07737C4.58890 1.86207 5.09160 1.86207 5.51727 2.07737C5.73131 2.18563 5.93060 2.38492 6.32918 2.78350L6.47533 2.92965C6.73754 3.19186 6.86864 3.32296 6.95436 3.45479C7.27760 3.95196 7.27760 4.59290 6.95435 5.09007C6.86864 5.22190 6.73754 5.35300 6.47533 5.61521C6.38960 5.70094 6.34673 5.74381 6.31085 5.79392C6.18334 5.97199 6.13932 6.23018 6.20061 6.44045C6.21786 6.49962 6.24031 6.54637 6.28521 6.63989Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Contact us
                </button>
              </div>
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-number">{years}</div>
                  <div className="stat-label">years in experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{clients}</div>
                  <div className="stat-label">helped clients</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{satisfaction}</div>
                  <div className="stat-label">satisfaction rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
 